import { render } from "./DialogSetting.vue?vue&type=template&id=52497e68"
import script from "./DialogSetting.vue?vue&type=script&lang=js"
export * from "./DialogSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__